<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/logo_white.png" alt="logo图">
    </div>
    <p class="title">我们一直都在</p>
    <p class="address_tel_fax">
      <span>地址：成都市高新区天府三街999号</span>
      <span>Tel：wand-code</span>
    </p>
    <p class="email_wx">
      <span>邮箱：200803390@qq.com</span>
      <span>微信：wand-code</span>
    </p>
    <p class="copy">Copyright &copy; 2016 - {{ new Date().getFullYear() }} 互动科技</p><a href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备2026023993号-1</a>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
  /* 👇 只改这一行：去掉原来的默认下边距，改为和copy行匹配的下边距 */
  margin: 0 0 10px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  /* 👇 只改这一行：把原来的50px上边距改为0，直接和上面的email_wx行贴合 */
  margin: 0 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
    /* 👇 移动端同步改这一行，和上面保持一致 */
    margin: 0 0 8px;
  }
.copy {
  font-size: 12px;
  /* 👇 移动端同步改这一行，去掉原来的30px上边距 */
  margin: 0 0 10px;
}
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue